import {
    Component,
    Input,
    OnInit
} from '@angular/core';

import {
    IReservation,
    IReservationRow
} from '../model/reservation';

interface IDay {
    TIME_MORNING: IItem;
    TIME_EVENING: IItem;
}

interface IItem {
    balls?      : string;
    pumps?      : string;
    car?        : any;
    hasContent? : boolean;
}

@Component({
    selector: 'bb-calendar-item',
    template: require('./calendar-item.component.html'),
})

export class CalendarItemComponent implements OnInit {
    @Input() public reservations: IReservationRow[]|void;
    @Input() public date: string;

    public reservation : IDay = {TIME_MORNING: {}, TIME_EVENING: {}};
    public times = ['TIME_MORNING', 'TIME_EVENING'];

    public ngOnInit() {
        for (let time of this.times)
        {
            let maxBalls = 16,
                balls    = 0,
                maxPumps = 5,
                pumps    = 0,
                car      = false,
                delivery = false,
                pickUp   = false,
                hasContent = false;

            if (this.reservations) {
                for (let reservation of this.reservations) {
                    if (time === reservation.time) {
                        hasContent = true;
                        for (let data of reservation.data) {
                            switch (data.type) {
                                case 'TYPE_BALL':
                                    balls += data.quantity;
                                    break;
                                case 'TYPE_PUMP':
                                    pumps += data.quantity;
                                    break;
                                case 'TYPE_CAR':
                                    car = true;
                                    break;
                                case 'TYPE_PICKUP':
                                    delivery = true;
                                    break;
                                case 'TYPE_DELIVERY':
                                    pickUp = true;
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                }

                this.reservation[time] = {
                    balls: balls + ' / ' + maxBalls,
                    pumps: pumps + ' / ' + maxPumps,
                    car: {car, delivery, pickUp},
                    hasContent
                };
            }
        }
    }
}
/*
    [
        {
            "reserver": {
                "id": 1,
                "firstname": "je",
                "lastname": "jo",
                "company": "c",
                "address": "addr",
                "phone": "1234",
                "allowMarketing": true
            },
            "date": "2017-03-15",
            "time": "TIME_MORNING",
            "data": [{"type": "TYPE_BALL", "quantity": 2}, {"type": "TYPE_CAR", "quantity": 1}]
        }
    ]
}*/



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/calendar/calendar-item.component.ts